import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';

import { Select as NhsUkSelect } from 'nhsuk-react-components';

const Select = forwardRef((props, ref) => {
    const [error, setError] = useState(undefined);
    const [isReadOnly, setIsReadOnly] = useState(undefined);
    const [isValid, setIsValid] = useState(undefined);

    useEffect(() => {
        setIsReadOnly(props.question.isReadOnly);
    }, [props.question.isReadOnly]);

    useEffect(() => {
        if (
            props.onConditionalReveal &&
            props.question.value !== undefined &&
            props.question.value !== null
        ) {
            toggleConditionalRevealQuestions(props.question.value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.question.value]);

    useImperativeHandle(ref, () => ({
        validate,
        isValid
    }));

    const validate = () => {
        if (props.question.mandatory) {
            if (!props.question.value) {
                setError(`Enter the ${props.question.name}`);
                setIsValid(false);
            } else {
                setError(undefined);
                setIsValid(true);
            }
        } else {
            setError(undefined);
            setIsValid(true);
        }
    };

    const normaliseQuestionRefs = questionRefs => {
        if (!questionRefs) {
            return [];
        }

        return Array.isArray(questionRefs) ? questionRefs : [questionRefs];
    };

    const getLinkedQuestionIds = questionRefs => {
        return normaliseQuestionRefs(questionRefs).map(question => question.id);
    };

    const toggleConditionalRevealQuestions = value => {
        const allLinkedIds = getLinkedQuestionIds(props.question.linked_questions);

        // If "Please Select" is chosen, hide all linked questions
        if (!value) {
            if (allLinkedIds.length > 0) {
                props.onConditionalReveal({
                    isRevealed: false,
                    questionIds: allLinkedIds
                });
            }

            return;
        }

        const selectedOption = props.question.options.find(option => option.key === value);

        const revealIds = new Set(getLinkedQuestionIds(selectedOption?.linked_question_id));

        const hideIds = allLinkedIds.filter(id => !revealIds.has(id));
        if (hideIds.length > 0) {
            props.onConditionalReveal({
                isRevealed: false,
                questionIds: hideIds
            });
        }

        if (revealIds.size > 0) {
            props.onConditionalReveal({
                isRevealed: true,
                questionIds: Array.from(revealIds)
            });
        }
    };

    const handleChange = async event => {
        await props.onChange({
            questionId: props.question.id,
            linked_questions: props.question.linked_questions || null,
            option: props.question.options.find(x => x.key === event.target.value) || null,
            value: event.target.value
        });

        if (props.onConditionalReveal && event.type === 'change') {
            toggleConditionalRevealQuestions(event.target.value);
        }
    };

    const isInOptions = props.question.options.some(obj => obj.key === props.question.value);
    var value;
    if (isInOptions) {
        value = props.question.value;
    } else {
        value = '';
        props.question.value = null;
    }

    return (
        <NhsUkSelect
            label={props.question.name}
            hint={props.question.hint_text}
            value={value}
            onChange={handleChange}
            error={error}
            disabled={isReadOnly}
            required={props.question.mandatory}
        >
            <NhsUkSelect.Option value="">Please Select</NhsUkSelect.Option>
            {props.question.options.map(option => (
                <NhsUkSelect.Option key={option.key} value={option.key}>
                    {option.value}
                </NhsUkSelect.Option>
            ))}
        </NhsUkSelect>
    );
});

export default Select;
